var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FileExportDropdown',{staticClass:"chat-export",attrs:{"url":_vm.url,"filename":_vm.filename}})
}
var staticRenderFns = []

export { render, staticRenderFns }